export default __webpack_public_path__ + "static/media/sass.0a40a158.svg";